import api from "../../../api";

const API_URL = "/crm/sales-targets"; // base url, tanpa localhost jika pakai proxy

/**
 * @param {Object} [params] - Optional query params for permission filtering
 * @param {string} [params.viewDepartmentId] - When set, backend returns only targets for this department (view_department permission)
 */
export async function getSalesTargets(params = {}) {
  const query = new URLSearchParams();
  if (params.viewDepartmentId != null && params.viewDepartmentId !== '') {
    query.append('viewDepartmentId', params.viewDepartmentId);
  }
  const queryString = query.toString();
  const url = queryString ? `${API_URL}?${queryString}` : API_URL;
  const res = await api.get(url);
  return res.data;
}

export async function getSalesTarget(id) {
  const res = await api.get(`${API_URL}/${id}`);
  return res.data;
}

export async function createSalesTarget(data) {
  const res = await api.post(API_URL, data);
  return res.data;
}

export async function updateSalesTarget(id, data) {
  const res = await api.put(`${API_URL}/${id}`, data);
  return res.data;
}

export async function deleteSalesTarget(id) {
  return api.delete(`${API_URL}/${id}`);
}

// Optional: filter by year (backend can decide how to handle this param)
export async function getSalesTargetsByYear(year) {
  const res = await api.get(`${API_URL}?year=${year}`);
  return res.data;
}

// Departments (business units)
export async function getDepartments() {
  const res = await api.get("/crm/departments");
  return res.data;
}

// Sales users with departmentId information
export async function getSalesUsers() {
  const res = await api.get("/dashboard/sales-users");
  // API returns { salesUsers: [...] }
  return res.data && res.data.salesUsers ? res.data.salesUsers : [];
}

